var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedIwocaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.26 0H6.7372C2.96813 0 0 2.97444 0 6.75151V113.406C0 117.184 2.96813 120.158 6.7372 120.158H113.59C117.359 120.158 120.092 117.184 119.998 113.406V6.75151C119.998 3.02166 116.982 0 113.26 0ZM105.911 106.23H14.134V14.0224L105.864 14.2112V106.23H105.911Z",
    fill: "#FB534A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.33 77.1475L82.7785 81.8689C83.6265 82.1994 84.5688 81.68 84.5688 80.6885V39.5657C84.5688 38.6214 83.6265 38.0076 82.7785 38.3853L71.33 43.2011C70.906 43.3899 70.5762 43.8621 70.5762 44.4759V76.0144C70.5762 76.4865 70.8117 76.9115 71.33 77.1475Z",
    fill: "#FB534A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1255 81.8688L48.5741 77.1475C49.0924 76.9586 49.3279 76.4865 49.3279 75.9671V44.4286C49.3279 43.8148 48.9981 43.3427 48.5741 43.1539L37.1255 38.3381C36.2775 38.0076 35.3352 38.6214 35.3352 39.5184V80.6412C35.3352 81.5855 36.2775 82.1993 37.1255 81.8688Z",
    fill: "#FB534A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedIwocaLogo);
export default __webpack_public_path__ + "static/media/red-iwoca-logo.6e41a1ef16c23c65619bd4030d6ad728.svg";
export { ForwardRef as ReactComponent };